import BigNumber from 'bignumber.js';

import { getDecimalsFromValue, numberAsBigNumberOrUndefined, numberOrDefault } from '@webtrader/core/format/number';

export const kSeparator = (value: number, decimals?: number) => {
  return new BigNumber(numberOrDefault(value)).toFormat(numberOrDefault(decimals, 1));
};

export const kSeparatorForNumberOrDecimals = (value: number) =>
  new BigNumber(value).toFormat(getDecimalsFromValue(value));

export const kSeparatorNoDecimals = (value: number) => new BigNumber(value).toFormat(0);

export const toPoints = (points: number) => {
  return Math.floor(points);
};

export const trimToDecimal = (value: number | undefined, decimals: number) => {
  return numberAsBigNumberOrUndefined(value)?.decimalPlaces(decimals, BigNumber.ROUND_DOWN).toNumber();
};

export const priceForDisplay = (value: number, decimal: number) => {
  return value ? kSeparator(value, decimal) : '--';
};

export const removeThousandSeparator = (value: string) => {
  return value.replace(/,/g, '');
};
